/** The company card in the console (24/10/2026): for now, blocking access. Twin of `it.ts`. */
export default {
  accesso: {
    titolo: 'Company access',
    spiegazione_libera: 'Blocking closes the accounts of the people who work for this company and suspends it: nobody gets in any more, neither from the web app nor from the phone apps. All data stays, and unblocking puts everything back as it was.',
    bloccata_dal: 'Access blocked since {{quando}}',
    bloccata_motivo: 'Reason: {{motivo}}',
    bloccata_da_skill: 'from the /probusiness skill',
    bloccata_da_console: 'from the console',
    bottone_blocca: 'Block access…',
    bottone_sblocca: 'Unblock access…',
    titolo_blocco: 'Block access for {{nome}}?',
    titolo_sblocco: 'Unblock access for {{nome}}?',
    caricamento: 'Preparing the summary…',
    piano: '{{piano}} plan',
    esente: 'Exempt: {{motivo}}',
    esente_senza_motivo: 'Exempt, no reason written',
    abbonamento: 'Subscription {{id}} ({{stato}})',
    nessun_abbonamento: 'No Stripe subscription',
    ultimo_pagamento: 'last payment on {{quando}}',
    pagato_in_passato: 'paid in the past',
    mai_pagato: 'never paid',
    ultima_attivita_azienda: 'Last time anyone from the company used the system: {{quando}}',
    mai: 'never',
    si_chiudono_one: '{{count}} account will be closed',
    si_chiudono_other: '{{count}} accounts will be closed',
    si_riaprono_one: '{{count}} account will be reopened',
    si_riaprono_other: '{{count}} accounts will be reopened',
    nessuno: 'None.',
    restano_chiusi: 'Stay closed: something else keeps them closed too',
    gia_chiusi: 'Already closed before: they stay closed, and unblocking does not reopen them',
    non_si_toccano: 'Not touched',
    chiuso_da: 'closed by: {{chi}}',
    chiuso_prima_del_registro: 'closed before the block register existed',
    persona_attivita: 'Last activity {{attivita}} · last sign-in {{ingresso}}',
    senza_ruolo: 'no role written',
    cosa_succede_blocco: 'The company becomes “suspended” (the web app shows the lockout screen), the accounts above are closed and open sessions drop, in the phone apps too (within an hour at most). All data stays and the people’s profiles are not touched.',
    cosa_succede_sblocco: 'The company goes back to its status before the block, and only the accounts the block closed, and that nothing else keeps closed, are reopened.',
    motivo: 'Why',
    motivo_aiuto_blocco: 'Kept in the company history (e.g. “never paid, gone since October”).',
    motivo_aiuto_sblocco: 'Optional: kept in the company history.',
    annulla: 'Cancel',
    conferma_blocco_one: 'Block access ({{count}} account)',
    conferma_blocco_other: 'Block access ({{count}} accounts)',
    conferma_sblocco: 'Unblock access',
    esito_blocco: 'Access blocked: {{count}} accounts closed.',
    esito_sblocco: 'Access unblocked: {{count}} accounts reopened.',
    esito_restano: '{{count}} stay closed for other reasons.',
    esito_errori: '{{count}} accounts could not be changed: check the logs.',
    errore: 'Failed: {{messaggio}}',
    motivi: {
      super_utente: 'super user, never',
      agente: 'WhatsApp agent, not a person',
      lavora_anche_per_altre_aziende: 'also works for another company: the account stays, and loses access here because the company is suspended',
      ospite_da_altra_azienda: 'works here from another company: the account belongs to the other one, and loses access here because the company is suspended',
      account_senza_azienda: 'account with no company in its permissions (a screen, a service account): support closes it',
      account_inesistente: 'profile without an account: nothing to close',
    },
    impedimenti: {
      gia_bloccata: 'Access for this company is already blocked.',
      non_bloccata: 'Access for this company is not blocked: there is nothing to unblock.',
      abbonamento_vivo: 'The company still has a live Stripe subscription: close that first, then block access.',
    },
  },
} as const;
